// extracted by mini-css-extract-plugin
export default {"sectionContentText":"BlockText_sectionContentText__2vIqw"};